import $$ from 'cmn-utils';

//查询终端异常
export async function qryMessagesOfClient(payload) {
	return $$.post('/message/qryMessagesOfClient', payload);
}

//批量置为已读
export async function batchUpdateClientMessages(payload) {
	return $$.post('/message/batchUpdateClientMessages', payload);
}

//批量置为已读
export async function markMessagesRead(payload) {
	return $$.post('/message/markMessagesRead', payload);
}

//全部置为已读
export async function clearClientMessages(payload) {
	return $$.post('/message/clearClientMessages', payload);
}

//查询未读消息总数
export async function qryNoReadMessageCount(payload) {
	return $$.post('/message/qryNoReadMessageCount', payload);
}





// WEBPACK FOOTER //
// ./src/routes/NavBar/StationNews/service/index.js